import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../utils/context/UserContext";
import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Space,
  Table,
  Typography,
  DatePicker,
  Select,
} from "antd";
import {
  ERROR_NOTIFICATION_TYPE,
  SUCCESS_NOTIFICATION_TYPE,
  getAPIResponseMessage,
} from "../../utils/api/_ConstantsAPI";
import { Content } from "antd/es/layout/layout";
import BranchDefaultType from "../../utils/types/BranchDefaultType";
import { getBranchSettingsFields } from "../../utils/data/BranchSettingsField";
import { FormInput } from "../../components";
import { IoIosRefresh } from "react-icons/io";
import { getBranchSettingsTable } from "../../utils/tableData/Maintenance/BranchSettingsTable";
import { getBranchInfo, updateBranchInfo } from "../../utils/api/BranchesAPI";
import { GlobalContext } from "../../App";
export default function BranchSettings() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const { profile, formItemLayout, getCurrentDate } = useContext(UserContext);
  const [settingState, setSettingState] = useState(BranchDefaultType);
  const [isRequesting, setIsRequesting] = useState(false);
  const { openNotification } = useContext(GlobalContext);
  const [localBranchInfo, setLocalBranchInfo] = useState([]);
  const tableContents = localBranchInfo;
  const [dateHidden, setDateHidden] = useState(true);
  const [profileAccess , setProfileAccess] = useState(profile.accessLevel);


  const fetchBranchSettings = async () => {
    resetData();
    setIsLoading(true);

    
    const res = await getBranchInfo(profile.branchCode);
    if (res.isSuccessful) {
      resetData();
      const settings = res.data[0];
      setLocalBranchInfo(res.data);
      setSettingState(settings);
      form.setFieldsValue(settings); // ✅ correct method
    } else {
      openNotification(
        ERROR_NOTIFICATION_TYPE,
        "Branch Settings",
        getAPIResponseMessage(res.data)
      );
    }
    setIsLoading(false);
  };

  const handleSaveRequest = async () => {
    setIsRequesting(true);
    // console.log(settingState);
    try {
      await form.validateFields();


      const requestData = {
        ...settingState,
        profile_id: profile.id, // or any key your API expects
      };


      const res = await updateBranchInfo(requestData);
    
      if (res.isSuccessful) {
        if (res.status == 1) {
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            "Branch Settings",
            getAPIResponseMessage(res.data)
          );
          resetData();
          fetchBranchSettings();
        } else if (res.status == 3) {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            "Branch Settings",
            res.data
          );
        }
      } else {
        openNotification(
          ERROR_NOTIFICATION_TYPE,
          "Branch Settings",
          getAPIResponseMessage(res.message)
        );
      }
    } catch (error) {
      //
    }
    setIsRequesting(false);
  };

  const resetData = () => {
    setSettingState(BranchDefaultType);
    form.resetFields();
    form.setFieldsValue(BranchDefaultType);
  };

  useEffect(() => {
    if (localBranchInfo.length === 0) {
      resetData();
      fetchBranchSettings();
    }
  }, []);

  useEffect(() => {
    const fetchDataInterval = setInterval(() => {
      resetData();
      fetchBranchSettings();
    }, 1800000);

    return () => {
      clearInterval(fetchDataInterval);
    };
  }, []);

  return (
    <Content>
      <Typography.Title level={3}>Branch Settings</Typography.Title>
      <Row justify="center" align="middle" gutter={16}>
        <Col xs={24} sm={12}>
          <Card hoverable bordered={false} loading={isLoading}>
            <Form
              form={form}
              name="branch_settings_form"
              {...formItemLayout}
              initialValues={settingState}
              onFinish={handleSaveRequest}
            >
              {getBranchSettingsFields(
                isRequesting,
                settingState,
                setSettingState,
                profileAccess,
              ).map((data, index) => (
                <FormInput
                  key={index}
                  type={data.type}
                  name={data.name}
                  placeholder={data.placeholder}
                  label={data.label}
                  autoFocus={data.autofocus}
                  value={data.value}
                  onChange={data.setValue}
                  required={data.required}
                  disabled={data.disabled}
                  dropdownOptions={data.dropdownOptions}
                />
              ))}

              <Row justify="center" align="middle">
                <Col xs={12}>
                  <Button
                    block
                    htmlType="submit"
                    type="primary"
                    disabled={isRequesting}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card
            hoverable
            bordered
            title="Current Branch"
            extra={
              <Space>
                <Button
                  type="primary"
                  size="large"
                  icon={<IoIosRefresh size={24} />}
                  loading={isRequesting}
                  // onClick={() => fetchBranchSettings()}
                  onClick={fetchBranchSettings}
                />
              </Space>
            }
          >
            <Table
              columns={getBranchSettingsTable()}
              dataSource={tableContents}
              size="small"
              bordered="true"
              scroll={{ x: true }}
              loading={isRequesting}
            />
          </Card>
        </Col>
      </Row>
    </Content>
  );
}
